import {I18n} from '@aws-amplify/core';

import {SubscriptionItem} from '../types';

export const getColumns = (onRecordClick?: (record: SubscriptionItem) => void) => [
    {
        title: I18n.get('Subscription Item'),
        width: '1fr',
        render: (item: SubscriptionItem) => onRecordClick ? (
            <span
                style={{color: 'var(--mantine-color-blue-6)', cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                {item.id}
            </span>
        ) : item.id,
    },
    {
        title: I18n.get('Price'),
        width: '1fr',
        render: (item: SubscriptionItem) => item.price,
    },
    {
        title: I18n.get('Quantity'),
        width: '1fr',
        render: (item: SubscriptionItem) => item.quantity,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: SubscriptionItem) => item.created?.toString(),
    },
];

// Keep backward-compatible export for any remaining consumers
export const columns = getColumns();
